import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ExternalLink, PlusCircle } from "lucide-react";
import { PROFILE_NAV_ITEMS } from "../profileNavigation";
import { fetchPremiumSocial } from "../../../api/premiumSocialService";

export default function ProfileSidebar() {
  const navigate = useNavigate();
  const [myTeam, setMyTeam] = useState(null);
  const [teamLoaded, setTeamLoaded] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    fetchPremiumSocial(controller.signal)
      .then((data) => {
        setMyTeam((data.teams || [])[0] || null);
        setTeamLoaded(true);
      })
      .catch(() => setTeamLoaded(true));
    return () => controller.abort();
  }, []);

  return (
    <aside className="sticky top-24 hidden self-start xl:block">
      <div className="w-[280px]">
        <nav className="rounded-[28px] border border-emerald-100 bg-white/85 p-3 text-pixy-ink shadow-[0_20px_60px_rgba(47,157,226,0.12)]">
          <div className="mb-2 px-3 py-2 text-[11px] uppercase tracking-[0.24em] text-slate-500">
            Navigation
          </div>
          <div className="space-y-1.5">
            {PROFILE_NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-2xl px-3 py-3 transition ${
                      isActive
                        ? "bg-[linear-gradient(135deg,#5fb56f,#2f9de2)] text-white shadow-lg"
                        : "text-slate-700 hover:bg-pixy-mist"
                    }`
                  }
                >
                  <Icon className="h-4 w-4 flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="truncate text-sm font-semibold">{item.label}</div>
                    <div className="truncate text-[11px] opacity-75">{item.description}</div>
                  </div>
                </NavLink>
              );
            })}

            {/* Dynamic team item */}
            {teamLoaded && (
              myTeam ? (
                <button
                  type="button"
                  onClick={() => navigate("/profile/team")}
                  className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-left text-slate-700 transition hover:bg-pixy-mist"
                >
                  <ExternalLink className="h-4 w-4 flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="truncate text-sm font-semibold">Mon équipe</div>
                    <div className="truncate text-[11px] opacity-75">[{myTeam.tag}] {myTeam.name}</div>
                  </div>
                </button>
              ) : (
                <NavLink
                  to="/profile/team"
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-2xl px-3 py-3 transition ${
                      isActive
                        ? "bg-[linear-gradient(135deg,#5fb56f,#2f9de2)] text-white shadow-lg"
                        : "text-slate-700 hover:bg-pixy-mist"
                    }`
                  }
                >
                  <PlusCircle className="h-4 w-4 flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="truncate text-sm font-semibold">Créer une équipe</div>
                    <div className="truncate text-[11px] opacity-75">Fonder votre team</div>
                  </div>
                </NavLink>
              )
            )}
          </div>
        </nav>
      </div>
    </aside>
  );
}
